import { HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthService } from '@app/services/auth/auth.service';

// Inject root
@Injectable({
    providedIn: 'root'
})

// Class Token interceptor for generating jwt token
// implements httpInterceptor
export class TokenInterceptorService implements HttpInterceptor {
    /**
     * constructor accepts authService
     * @param authService 
     */
    constructor(private readonly authService: AuthService) { }

    /**
    * @description to add a token in every api
    */
    intercept(req: HttpRequest<any>, next: HttpHandler) {
        if (!this.authService.proxyLogin) {
            let roles = '';
            if (this.authService.getRoles()) {
                roles = this.authService.getRoles().toString();
            }
            req = req.clone({
                setHeaders: {
                    // add the token in Bearer
                    Authorization: this.authService.getAuthorizationHeaderValue(),
                    roles
                }
            });
        }
        return next.handle(req);
    }
}